module.exports = __webpack_public_path__ + "static/img/3.d03d80f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/woman/product/3.jpg
// module id = vzg7
// module chunks = 0